export const BRANCHNAME = "production-simulation";export const GITSHASHORT = "182532bf";export const GITSHALONG = "182532bf566f20f08a6e26f12f4f943fc98332e1";